/**
 * weiboSignTableModule
 * description：融合审签-weibo表格组件
 * author：Qian.qianchen
 */
'use strict';
angular.module('weiboSignTableModule', []).directive('weiboSignTable', [
    '$q',
    'trsHttpService',
    'storageListenerService',
    'modalDialog',
    'editingCenterService',
    '$filter',
    '$state',
    'weiboConst',
    'newMediaService',
    function($q, trsHttpService, storageListenerService, modalDialog, editingCenterService, $filter, $state, weiboConst, newMediaService) {
        return {
            restrict: 'E',
            replace: false,
            templateUrl: './editingCenter/iWo/fusionSign/directive/weiboSignTable/weiboSignTable_tpl.html',
            scope: {
                productInfo: '=',
                selectedArray: '=',
                fromDate: '=',
                untilDate: '=',
                channelValue: '=',
                page: '='
            },
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        DocType: '',
                    };
                    $scope.newOperationParams = {
                        serviceid: 'mlf_fusion',
                        methodname: 'doActionOnMediaTypeAndDocIdsSync',
                        oprType: 'daishen',
                        actionKey: '',
                    };
                    $scope.data = {
                        tableData: [],
                    };
                    $scope.$on('refresh', function() {
                        requestData();
                    });
                }

                /**
                 * [initData description] 数据初始化
                 * @return {[type]} [description]
                 */
                function initData() {
                    listenStorage();
                    requestData();
                }

                /**
                 * [listenStorage description]监听本地缓存
                 * @return {[promise]} [description] promise
                 */
                function listenStorage() {
                    storageListenerService.listenToWeibo(function() {
                        requestData();
                        storageListenerService.removeListener('weibo');
                    }, $scope);
                }

                /**
                 * [requestData description] 表格数据请求
                 * @return {[type]} [description]
                 */
                function requestData() {
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_fusion',
                        methodname: 'queryFusionDocumentsInShenQian',
                        // SiteId: $scope.productInfo.SITEID,
                        CurrPage: $scope.page.CURRPAGE,
                        PageSize: $scope.page.PAGESIZE,
                        OprTime: $scope.status.OprTime,
                        // DocType: $scope.status.DocType,
                        OprTimeStart: angular.isDefined($scope.fromDate) ? $scope.fromDate : '',
                        OprTimeEnd: angular.isDefined($scope.untilDate) ? $scope.untilDate : '',
                        // CHANNELID: ''
                        isPass: $scope.$parent.status.isPass,
                        MediaTypes: '5',
                        ChannelId: $scope.$parent.data.channelValue
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $scope.data.tableData = data.DATA;
                        $scope.data.items = data.DATA;
                        if ($scope.data.items.length) {
                            editingCenterService.queryVerifyDoc($scope.data.items);
                        }
                        newMediaService.getReviseInfo($scope.data.items);
                        $scope.data.itemCount = data.PAGER.ITEMCOUNT;
                        $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                        $scope.page.CURRPAGE = data.PAGER.CURRPAGE;
                        $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                        $scope.page.PAGECOUNT = data.PAGER.PAGECOUNT;
                        $scope.selectedArray = [];
                        deffer.resolve(data);
                    });
                    return deffer.promise;
                }

                /**
                 * [timeFormat description] 日期day+1处理
                 * @param  {[String]} timeStr [description]日期字符串
                 * @return {[type]}         [description]
                 */
                function timeFormat(timeStr) {
                    if (angular.isDefined(timeStr) && timeStr != '') {
                        var date = timeStr.replace(/-/g, '/');
                        var timestamp = new Date(date).getTime();
                        timestamp = timestamp + 24 * 60 * 60 * 1000;
                        var d = new Date(timestamp);
                        return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
                    } else {
                        return '';
                    }
                }

                /**
                 * [formatToStringTime 时间戳转换成 YYYY-MM-dd HH:mm:ss]
                 * @param {[type]} timestamp [description]
                 * @return {[type]} [description]
                 */
                function formatToStringTime(timestamp) {
                    let year, month, days, hours, minutes, seconds, time, result;
                    timestamp = new Date(timestamp);
                    year = timestamp.getFullYear();
                    month = timestamp.getMonth() + 1 < 10 ? '0' + (timestamp.getMonth() + 1) : timestamp.getMonth() + 1;
                    days = timestamp.getDate() < 10 ? '0' + timestamp.getDate() : timestamp.getDate();
                    hours = timestamp.getHours() < 10 ? '0' + timestamp.getHours() : timestamp.getHours();
                    minutes = timestamp.getMinutes() < 10 ? '0' + timestamp.getMinutes() : timestamp.getMinutes();
                    seconds = timestamp.getSeconds() < 10 ? '0' + timestamp.getSeconds() : timestamp.getSeconds();
                    result = year + '-' + month + '-' + days + ' ' + hours + ':' + minutes + ':' + seconds;
                    return result;
                }

                /**
                 * [hasEditRight description] 判断用户是否有稿件编辑权限
                 * @param  {[type]}  item [description] 稿件
                 * @return {Boolean}      [description]
                 */
                function hasEditRight(item) {
                    var defer = $q.defer();
                    var params = {
                        serviceid: 'mlf_fusion',
                        methodname: 'checkUserHasChannelDaiShenEditRight',
                        mediaType: 5,
                        objectId: item.SCMMICROCONTENTID,
                        accountId: $scope.productInfo.ACCOUNTID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        defer.resolve(data);
                    });
                    return defer.promise;
                }

                /**
                 * [selectItem description] 稿件选择/取消选择
                 * @param  {[type]} item [description] 稿件
                 * @return {[type]}      [description]
                 */
                $scope.selectItem = function(item) {
                    if ($scope.isChecked(item)) {
                        $scope.selectedArray = $scope.selectedArray.filter(function(_item, index) {
                            return item.SCMMICROCONTENTID != _item.SCMMICROCONTENTID;
                        });
                    } else {
                        $scope.selectedArray.push(item);
                    }
                };

                /**
                 * [isChecked description] 判断稿件是否选中
                 * @param  {[type]}  item [description] 稿件
                 * @return {Boolean}      [description]
                 */
                $scope.isChecked = function(item) {
                    return $scope.selectedArray.some(function(_item, index) {
                        return item.SCMMICROCONTENTID == _item.SCMMICROCONTENTID;
                    });
                };

                /**
                 * [selectAll description] 全选/取消全选
                 * @return {[type]} [description]
                 */
                $scope.selectAll = function() {
                    if ($scope.selectedArray.length == $scope.data.tableData.length) {
                        $scope.selectedArray = [];
                    } else {
                        $scope.selectedArray = angular.copy($scope.data.tableData);
                    }
                };

                /**
                 * [editWeibo description] 编辑微博
                 * @param  {[object]} item [description] 微博对象
                 * @return {[type]}      [description]
                 */
                $scope.editWeibo = function(item) {
                    $scope.editWeibo = function(item) { 
                        let routerParams = {
                            wbplatform: item.PLATFORM - 1,
                            wbchannelid: item.PRODUCTID,
                            wbmetadataid: item.METADATAID,
                        };
                        let url = $state.href(weiboConst.doctype[item.DOCTYPEID], routerParams);
                        window.open(url);
                    };
                };

                /**
                 * [isSelectTime description] 是否进行了时间筛选
                 * @return {Boolean} [description]
                 */
                $scope.isSelectTime = function() {
                    var res =
                        (angular.isUndefined($scope.fromDate) || !$scope.fromDate) &&
                        (angular.isUndefined($scope.untilDate) || !$scope.untilDate);
                    return res;
                };

                /**
                 * [showMore description] 加载更多
                 * @return {[type]} [description]
                 */
                $scope.showMore = function() {
                    $scope.status.page.PAGESIZE += 10;
                    requestData();
                };

                /**
                 * [loadSpecialData description] 加载特殊时间条件数据
                 * @param  {[type]} oprTime [description] 时间条件（1天/3天）
                 * @return {[type]}         [description]
                 */
                $scope.loadSpecialData = function(oprTime) {
                    var currDate = new Date();
                    var currYear = currDate.getFullYear();
                    var currMonth = currDate.getMonth() < 10 ? '0' + (currDate.getMonth() + 1) : currDate.getMonth() + 1;
                    var currDay = currDate.getDate() < 10 ? '0' + currDate.getDate() : currDate.getDate();
                    var currHour = currDate.getHours() < 10 ? '0' + currDate.getHours() : currDate.getHours();
                    var currMinute = currDate.getMinutes() < 10 ? '0' + currDate.getMinutes() : currDate.getMinutes();
                    var currSecond = currDate.getSeconds() < 10 ? '0' + currDate.getSeconds() : currDate.getSeconds();
                    var startTime = '';
                    var endTime = currYear + '-' + currMonth + '-' + currDay + ' ' + currHour + ':' + currMinute + ':' + currSecond;
                    startTime = formatToStringTime(new Date(endTime) - oprTime * 24 * 60 * 60 * 1000 + 1000);
                    $scope.fromDate = startTime;
                    $scope.untilDate = endTime;
                    requestData(false);
                };

                // /**
                //  * [showVersionTime description] 获取流程记录
                //  * @param  {[object]} item [description] 微博对象
                //  * @return {[type]}      [description]
                //  */
                // $scope.showVersionTime = function(item) {
                    
                //     editingCenterWeiBoService.processRecord(item);
                // };
                /**
             * [showVersionTime description] 流程版本时间与操作日志
             * @param   {[object]}  item  [item description] 稿件对象
             * @return  {[type]}          [return description]
             */
                $scope.showVersionTime = function (item) {
                    editingCenterService.getVersionTime(item, false);
                };

                /**
                 * [directSign description]
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.directSign = function(item) {
                    var deffer = $q.defer();
                    $scope.newOperationParams.actionKey = 'qianfa';
                    $scope.newOperationParams.mediaTypeDocIds = [
                        { 
                            MEDIATYPE: item.MEDIATYPE,
                            DOCID: item.METADATAID
                        }
                    ];
                    $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
                    modalDialog.confirmModal('签发', '确认发布稿件', function () {
                        $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then((data) => {
                            modalDialog.alertType('直接签发成功', '', 'success', false, function () {
                                requestData();
                            });
                        }, function () {
                            requestData();
                        });
                    });
                   
                    // item.SCMMICROCONTENTID = item.METADATAID;
                    // editingCenterWeiBoService.directSignWeibo([item], false, '40', function(result) {
                    //     if (result == 'success') {
                    //         modalDialog.alertType('直接签发成功', '', 'success', false);
                    //         $scope.callback();
                    //     } else {
                    //         modalDialog.alertType('该微博直接签发失败！', result.result.detail, 'error', 'confirm', function() {});
                    //     }
                    // }, function () {
                    // });
                    return deffer.promise;
                };

                /**
                 * [trial description]
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.trial = function(item) {
                    item.SCMMICROCONTENTID = item.METADATAID;
                    modalDialog.inputModel('撤稿', '撤稿原因（选填）', function (content) {
                        rejection(item, content);
                    });
                };

                /**
                 * [rejection description]
                 * @param   {[type]}  item     [item description]
                 * @return  {[type]}           [return description]
                 */
                function rejection(item) {
                    $scope.newOperationParams.actionKey = 'tuigao';
                    $scope.newOperationParams.mediaTypeDocIds = [
                        { 
                            MEDIATYPE: item.MEDIATYPE,
                            DOCID: item.METADATAID
                        }
                    ];
                    $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
                    $scope.$parent.$parent.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.newOperationParams, 'get').then((data) => {
                        modalDialog.alertType('撤稿成功', '', 'success', false, function () {
                            requestData();
                        });
                    }, function () {
                        requestData();
                    });
                    
                }

                /**
                 * [timeSign description]
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                $scope.timeSign = function(item) {
                    $scope.newOperationParams.selectedArray = [item];
                    $scope.newOperationParams.actionKey = 'dingshiqianfa';
                    $scope.newOperationParams.mediaTypeDocIds = [
                        { 
                            MEDIATYPE: item.MEDIATYPE,
                            DOCID: item.METADATAID
                        }
                    ];
                    $scope.newOperationParams.mediaTypeDocIds = JSON.stringify($scope.newOperationParams.mediaTypeDocIds);
                    $scope.$parent.$parent.loadingPromise = editingCenterService.draftTimeSinged($scope.newOperationParams).then(function (data) {
                        modalDialog.alertType('定时签发成功', '', 'success', false, function () {
                            requestData();
                        });
                    }, function (result) {
                        requestData();
                    });
                };

                /**
                 * [weiboPreview description] 微博预览
                 * @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.weiboPreview = function (item) {
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,PUBLISHACCOUNTIDS,PRODUCTID', 'wbPreview');
                };

                /**
                 * [getCover 获取头条封面图]
                 * @param   {[type]}  item  [item description]
                 * @return  {[type]}        [return description]
                 */
                $scope.getCover = function(item){
                    if (item.COVER){
                        return $filter('trsWcmPic')(item.COVER);
                    } else {
                        return './static/picture_default.jpg';
                    }
                };
                
                $scope.isPass = function(item, flag) {
                    $scope.$parent.$parent.loadingPromise = newMediaService.isPass([item], flag).then(function(data) {
                        $scope.callback();
                    });
                };
            },
        };
    },
]);
